// extracted by mini-css-extract-plugin
module.exports = {"bigHeader":"SolutionDesc_bigHeader__2UjcL","image":"SolutionDesc_image__3jhlu"};